import { type ImageInterface } from 'Image/types';
import { originalUrl } from './originalUrl';

// The image-resizer Cloudflare worker resizes JIT based on w/h query params
// on the original image's URL. GIFs and SVGs are passed through by the worker,
// so callers do not need to special-case them.
export function sizedUrl(image: ImageInterface | null | undefined, width: number, height: number): string | null {
    const url = originalUrl(image);
    if (!url) return null;

    // Old content can hold urls that cannot be parsed (relative paths, data urls, etc.).
    // Serve those as-is rather than throwing.
    let urlObj: URL;
    try {
        urlObj = new URL(url);
    } catch {
        return url;
    }

    urlObj.searchParams.set('w', String(width));
    urlObj.searchParams.set('h', String(height));
    return urlObj.toString();
}

export default sizedUrl;
